import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

/**
 * Génère un PDF contenant les informations de connexion et la signature
 * @param {Object} userData - Données utilisateur (email, password, etc.)
 * @param {string} signatureTemplate - Template HTML de la signature (optionnel)
 */
const generateCredentialsPDF = (userData, signatureTemplate = null) => {
  // Créer une nouvelle instance de jsPDF
  const doc = new jsPDF();

  // Ajouter le logo (si disponible)
  // doc.addImage('logo.png', 'PNG', 10, 10, 40, 40);

  // Titre
  doc.setFontSize(20);
  doc.setTextColor(41, 128, 185); // Bleu
  doc.text("Informations de connexion", 105, 20, { align: 'center' });

  // Sous-titre
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text(`Plateau Urbain - ${new Date().toLocaleDateString('fr-FR')}`, 105, 30, { align: 'center' });

  // Ligne de séparation
  doc.setDrawColor(41, 128, 185);
  doc.line(20, 35, 190, 35);

  // Informations de l'utilisateur
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  
  // Tableau des informations
  const tableColumn = ["Information", "Valeur"];
  const tableRows = [
    ["Nom", userData.lastName || ""],
    ["Prénom", userData.firstName || ""],
    ["Fonction", userData.fonction || ""],
    ["Adresse email", userData.email || ""],
    ["Mot de passe temporaire", userData.password || ""],
    ["Téléphone", userData.telephone || ""],
    ["Adresse", `${userData.adresse1 || ""} ${userData.adresse2 || ""}`],
    ["Code postal / Ville", `${userData.codePostal || ""} ${userData.ville || ""}`]
  ];

  // Utilisation correcte d'autoTable
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 50,
    theme: 'grid',
    headStyles: { fillColor: [41, 128, 185] },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    styles: { fontSize: 10 }
  });

  // Instructions
  let yPos = doc.lastAutoTable.finalY + 20;
  doc.setFontSize(12);
  doc.setTextColor(41, 128, 185);
  doc.text("Instructions de connexion:", 20, yPos);
  
  yPos += 10;
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const instructions = [
    "1. Rendez-vous sur Gmail (gmail.com) ou configurez votre client mail",
    "2. Connectez-vous avec l'adresse email et le mot de passe ci-dessus",
    "3. Lors de votre première connexion, modifiez votre mot de passe",
    "4. Votre signature sera appliquée automatiquement",
    "5. En cas de problème, contactez votre administrateur système"
  ];
  
  instructions.forEach(line => {
    doc.text(line, 25, yPos);
    yPos += 7;
  });

  // Section signature si fournie
  if (signatureTemplate) {
    yPos += 15;
    doc.setFontSize(12);
    doc.setTextColor(41, 128, 185);
    doc.text("Aperçu de votre signature email:", 20, yPos);
    
    yPos += 10;
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("(La signature sera automatiquement configurée dans votre email)", 20, yPos);
    
    // Cadre pour la signature
    yPos += 10;
    doc.setDrawColor(200, 200, 200);
    doc.rect(20, yPos, 170, 30);
    
    yPos += 8;
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0);
    
    // Extraire les informations principales de la signature HTML pour un aperçu textuel
    const signatureLines = [];
    
    // Ligne nom/fonction
    if (userData.firstName || userData.lastName) {
      const nameLine = `${userData.firstName || ""} ${userData.lastName || ""}`.trim();
      const functionPart = userData.fonction ? ` | ${userData.fonction}` : "";
      signatureLines.push(nameLine + functionPart);
    }
    
    // Ligne téléphone
    if (userData.telephone) {
      signatureLines.push(`Tel: ${userData.telephone}`);
    }
    
    // Ligne adresse
    const addressParts = [];
    if (userData.adresse1) addressParts.push(userData.adresse1);
    if (userData.adresse2) addressParts.push(userData.adresse2);
    if (addressParts.length > 0) {
      signatureLines.push(addressParts.join(" "));
    }
    
    // Ligne code postal/ville
    const locationParts = [];
    if (userData.codePostal) locationParts.push(userData.codePostal);
    if (userData.ville) locationParts.push(userData.ville);
    if (locationParts.length > 0) {
      signatureLines.push(locationParts.join(" "));
    }
    
    // Site web
    signatureLines.push("plateau-urbain.com");
    
    const signatureText = signatureLines.filter(line => line.trim());

    signatureText.forEach(line => {
      if (yPos < 280) { // Vérifier qu'on ne déborde pas de la page
        doc.text(line, 25, yPos);
        yPos += 5;
      }
    });
  }

  // Note de sécurité
  doc.setFontSize(8);
  doc.setTextColor(231, 76, 60); // Rouge
  doc.text("CONFIDENTIEL : Ce document contient des informations sensibles. À conserver en sécurité.", 105, 280, { align: 'center' });

  // Pied de page
  doc.setFontSize(7);
  doc.setTextColor(100, 100, 100);
  doc.text("Généré automatiquement par Email & Signature Manager - Plateau Urbain", 105, 290, { align: 'center' });

  // Enregistrer le PDF avec un nom plus descriptif
  const fileName = userData.email ? 
    `plateau-urbain_identifiants_${userData.email.split('@')[0]}.pdf` : 
    `plateau-urbain_identifiants_${userData.firstName || 'utilisateur'}_${userData.lastName || ''}.pdf`;
  
  doc.save(fileName);
};

export default generateCredentialsPDF; 